
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { BaseService } from '../shared/base.service';
import { Observable } from 'rxjs';
import { ProjectMeta } from '../projects/project.model';
import { Revision } from './revision/revision.model';
import { Branch } from './branch.model';
import {HttpHeaders, HttpParams} from '@angular/common/http';

@Injectable()
export class VersionControlService extends BaseService {

  getBranchesOfRepo(repoUrl: string, projectKey?: string, inventoryKey?: string, user?: string, pass?: string): Observable<Branch[]> {
    const url = `/vc/branches`;
    let params = new HttpParams().set('repoUrl', repoUrl);
    if (projectKey) {
      params = params.set('projectKey', projectKey);
    }
    if (inventoryKey) {
      params = params.set('inventoryKey', inventoryKey);
    }

    let headers = new HttpHeaders();
    if (user) {
      headers = headers.set('X-Git-User', user);
    }
    if (pass) {
      headers = headers.set('X-Git-Pass', pass);
    }

    return this.httpGetUnwrapped(url, headers, params);
  }

  getBranchByRepoAndName(repoUrl: string, branchName: string, projectKey?: string, inventoryKey?: string, user?: string, pass?: string): Observable<Branch | undefined> {
    const url = `/vc/branches`;
    let params = new HttpParams()
        .set('repoUrl', repoUrl)
        .set('name', branchName);
    if (projectKey) {
      params = params.set('projectKey', projectKey);
    }
    if (inventoryKey) {
      params = params.set('inventoryKey', inventoryKey);
    }

    let headers = new HttpHeaders();
    if (user) {
      headers = headers.set('X-Git-User', user);
    }
    if (pass) {
      headers = headers.set('X-Git-Pass', pass);
    }

    return this.httpGetUnwrapped(url, headers, params).pipe(
        map((branches: Branch[]) => {
          if (!branches?.length) {
            console.warn(`No branch found for ${branchName} in repo ${repoUrl}`);
            return undefined;
          }
          return branches[0];
        })
    );
  }

  getProjectStatus(projectKey: string): Observable<ProjectMeta> {
    const url = `/projects/${projectKey}/meta`;
    return this.httpGet(url);
  }

  getRevisionOfProjectCommit(projectKey: string, commitId: string): Observable<Revision> {
    const url = `/projects/${projectKey}/revisions/${commitId}`;
    return this.httpGet(url);
  }

  getRevisionOfInventoryCommit(inventoryKey: string, commitId: string): Observable<Revision> {
    const url = `/inventories/${inventoryKey}/revisions/${commitId}`;
    return this.httpGet(url);
  }
}
